import { render, staticRenderFns } from "./cargoButtonContainer.vue?vue&type=template&id=13ff2dc4&"
import script from "./cargoButtonContainer.vue?vue&type=script&lang=js&"
export * from "./cargoButtonContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13ff2dc4')) {
      api.createRecord('13ff2dc4', component.options)
    } else {
      api.reload('13ff2dc4', component.options)
    }
    module.hot.accept("./cargoButtonContainer.vue?vue&type=template&id=13ff2dc4&", function () {
      api.rerender('13ff2dc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/cargoButtonContainer.vue"
export default component.exports